import { Flex, Space } from "antd";
import { useIntl } from "react-intl";
import CustomSelect from "~components/CustomSelect";
import SearchFilter from "~components/SearchFilter/SearchFilter";
import SelectAgeGroup from "~components/SelectAgeGroup";
import SelectGender from "~components/SelectGender";
import SelectSeasonStatus from "~components/SelectSeasonStatus";
import type { LabelValue } from "~types/labelValue";
import type { SeasonFilterParams } from "../types";

type Props = {
  values: SeasonFilterParams;
  onFilterChange: (filterType: keyof SeasonFilterParams, value: string | null) => void;
  disabled: boolean;
  competitionOptions: LabelValue[];
};

const SeasonFilters = ({ onFilterChange, disabled, values, competitionOptions }: Props) => {
  const { formatMessage } = useIntl();

  return (
    <Flex justify="space-between" align="center">
      <Space size={8}>
        <CustomSelect
          style={{ minWidth: 250 }}
          value={values.competitionId}
          onChange={(value) => onFilterChange("competitionId", value as string)}
          options={competitionOptions}
          placeholder={formatMessage({ id: "competitionname" })}
          allowClear
          disabled={disabled}
        />
        <SelectGender value={values.gender} onChange={(value) => onFilterChange("gender", value)} disabled={disabled} />
        <SelectAgeGroup value={values.ageGroup} onChange={(value) => onFilterChange("ageGroup", value)} disabled={disabled} />
        <SelectSeasonStatus value={values.status} onChange={(value) => onFilterChange("status", value)} disabled={disabled} />
      </Space>
      <SearchFilter searchValue={values.searchText} doSearch={(value) => onFilterChange("searchText", value)} style={{ minWidth: 200 }} />
    </Flex>
  );
};

export default SeasonFilters;
